import { all, fork, put, takeEvery } from "redux-saga/effects";
import MenuService from '../../services/menu.service';
import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";


function* getMenuList(action) {
  try {
    if (action.payload) {
      const response = yield MenuService.list(action.payload);//params
      if (response?.data.statusCode === 200) {
        yield put(actions.getMenuListSuccess(response.data));
      } else {
        yield put(actions.getMenuListFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    yield put(actions.getMenuListFailure(error));
  }
}

function* getMenuListSaga() {
  yield takeEvery(actionsTypes.GET_MENU_LIST_START, getMenuList);
}

function* addMenu(action) {
  try {
    if (action.payload) {
      let payload = action.payload
      const data = new FormData();
      data.append('title',payload.title);
      data.append('details',payload.details);
      data.append('file',payload.file);
      data.append('order',payload.order);
      data.append('price',payload.price);
      data.append('serving_time',payload.serving_time);
      data.append('is_addon',payload.is_addon);
      data.append('is_drink',payload.is_drink);
      data.append('status',payload.status);
      data.append('category_id',payload.category_id);
      data.append('restaurant_branch_id',payload.restaurant_branch_id);
      data.append('addons',payload.addons);
      const response = yield MenuService.add(data);//params
      if (response?.data.statusCode === 201) {
        yield put(actions.addMenuSuccess(response.data));
      } else {
        yield put(actions.addMenuFailure("network error")); 
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    yield put(actions.addMenuFailure(error));
  }
}

function* addMenuSaga() {
  yield takeEvery(actionsTypes.ADD_MENU_START, addMenu);
}

function* updateMenu(action) {
  try {
    if (action.payload) {
      let payload = action.payload
      const data = new FormData();
      data.append('title',payload.title);
      data.append('details',payload.details);
      if(payload.file)
        data.append('file',payload.file);
      if(payload.order)
        data.append('order',payload.order);
      data.append('price',payload.price);
      data.append('serving_time',payload.serving_time);
      if(payload.is_addon)
        data.append('is_addon',payload.is_addon);
      if(payload.is_drink)
        data.append('is_drink',payload.is_drink);
      data.append('status',payload.status);
      data.append('category_id',payload.category_id);
      if(payload.addons)
        data.append('addons',payload.addons);
      // Clean and validate the productId
      let productId = action.payload?._id;
      if(typeof productId === 'string') {
        productId = productId.trim();
      }
      const response = yield MenuService.update(data,productId);//params
      if (response?.data.statusCode === 200) {
        yield put(actions.updateMenuSuccess(response.data));
      } else {
        yield put(actions.updateMenuFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    yield put(actions.updateMenuFailure(error));
  }
}

function* getProductLanguage(action){
  try {
    if (action.payload) {
      const response = yield MenuService.getProductLanguage(action.payload);//params
      if (response?.data.statusCode === 200) {
        yield put(actions.getProductLanguageSuccess(response.data));
      } else {
        yield put(actions.getProductLanguageFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    yield put(actions.getProductLanguageFailure(error));
  }
}

function* addProductLanguage(action){
  try {
  
      let response;
      let payload = action.payload;
       // Create FormData object to send file
      let create = payload.create;
      delete payload.create;
      
      if (create) {
        // create user flow
        delete payload._id
      }
      response = yield MenuService.addProductLanguage(payload);
      if (response?.data.statusCode === 201) {
        //
        yield put(actions.addProductLanguageSuccess(response.data));
      } else {
        yield put(actions.addProductLanguageFailure("network error"));
      }
    } catch (err) {
      // 
      let error = err?.response?.data?.message;
      if (!error) {
        error = "network error"
      }
      yield put(actions.addProductLanguageFailure(error));
    }
}

function* updateProductLanguage(action){
  try {
  
      let response;
      let payload = action.payload;

      const productLanguageId = action.payload?._id;
      response = yield MenuService.updateProductLanguage(payload, productLanguageId);
      if (response?.data.statusCode === 200) {
        yield put(actions.updateProductLanguageSuccess(response.data));
      } else {
        yield put(actions.updateProductLanguageFailure("network error"));
      }
    } catch (err) {
      // 
      let error = err?.response?.data?.message;
      if (!error) {
        error = "network error"
      }
      yield put(actions.updateProductLanguageFailure(error));
    }
}

function* updateMenuSaga() {
  yield takeEvery(actionsTypes.UPDATE_MENU_START, updateMenu);
}

function* getProductLanguageSaga(){
  yield takeEvery(actionsTypes.GET_PRODUCT_LANGUAGE_START, getProductLanguage);
}

function* addProductLanguageSaga(){
  yield takeEvery(actionsTypes.ADD_PRODUCT_LANGUAGE_START, addProductLanguage);
}

function* updateProductLanguageSaga(){
  yield takeEvery(actionsTypes.UPDATE_PRODUCT_LANGUAGE_START, updateProductLanguage);
}

function* listAddons(action){
  try {  
    const response = yield MenuService.listAddons(action.payload);
    
    if (response?.data.statusCode === 200) yield put(actions.getAddonsListSuccess(response.data));
    else yield put(actions.getAddonsListFailure("network error"));
  } catch (error) {
    yield put(actions.getAddonsListFailure(error));
  }
}

function* getAddonsListSaga() {
  yield takeEvery(actionsTypes.GET_ADDONS_LIST_START, listAddons);
}


export function* menuSaga() {
  yield all([fork(getMenuListSaga), fork(addMenuSaga), fork(updateMenuSaga), fork(getProductLanguageSaga), fork(addProductLanguageSaga), fork(updateProductLanguageSaga), fork(getAddonsListSaga) ]);
}
